export default __webpack_public_path__ + "static/media/Power_Małgorzata Szmigiel_ WARSZAWA.64dd523b.pdf";